module.exports = __webpack_public_path__ + "img/exams.6d39359c.png";